import React, { useEffect, useState } from "react";
import { CATEGORIES_API, OUR_SOLUTION_API } from "../../../../Utilities/APIs";
import Form from "../../../Partials/Layouts/Forms/Form";
import ShortTextInput from "../../../Partials/Layouts/Forms/FormInputs/ShortTextInput/ShortTextInput";
import ImageInput from "../../../Partials/Layouts/Forms/FormInputs/ImageInput/ImageInput";
import FormSubmitButton from "../../../Partials/Layouts/Forms/FormSubmitButton/FormSubmitButton";
import NumberInput from "../../../Partials/Layouts/Forms/FormInputs/NumberInput/NumberInput";
import useAxiosInstance from "../../../../Utilities/Hooks/useAxiosInstance";
import SelectInput from "../../../Partials/Layouts/Forms/FormInputs/SelectInput/SelectInput";
import SelectOption from "../../../Partials/Layouts/Forms/FormInputs/SelectInput/SelectOption/SelectOption";

function UpdateOurSolution({
  targetID,
  triggerFetch,
  setShowUpdateForm,
  setShowModal,
}) {
  const [name, setName] = useState("");
  const [image, setImage] = useState("");
  const [precedence, setPrecedence] = useState("");
  const [description, setDescription] = useState("");
  const [backgroundColor, setBackgroundColor] = useState("");
  const axiosInstance = useAxiosInstance();
  const [category, setCategory] = useState("");
  const [catagories, setCatagories] = useState(null);

  useEffect(() => {
    async function fetchAndSetCatagories() {
      const { data } = await axiosInstance.get(CATEGORIES_API);
      setCatagories(data);
    }
    fetchAndSetCatagories();
  }, [axiosInstance]);

  useEffect(() => {
    async function fetchAndSetTestimonialInfo() {
      const { data } = await axiosInstance.get(OUR_SOLUTION_API + targetID);
      setName(data.name);
      setDescription(data.description);
      setPrecedence(data?.precedence);
      setImage(data.image);
      setBackgroundColor(data.backgroundColor);
    }
    fetchAndSetTestimonialInfo();
  }, [targetID, axiosInstance]);

  async function handleSubmit(e) {
    e.preventDefault();

    const itemData = new FormData();

    itemData.append("name", name);
    itemData.append("image", image);
    itemData.append("category", category);
    itemData.append("description", description);
    itemData.append("backgroundColor", backgroundColor);
    itemData.append("precedence", precedence);

    const response = await axiosInstance.patch(
      OUR_SOLUTION_API + targetID,
      itemData
    );

    if (response) {
      setShowUpdateForm(false);
      setShowModal(false);
      triggerFetch();
    }
  }

  return (
    <Form onSubmit={handleSubmit} hasImage>
      <SelectInput label={"Category"} value={category} setState={setCategory}>
        <SelectOption optionValue="" optionText="Select Category" />
        {catagories?.map((category) => (
          <SelectOption
            optionValue={category._id}
            key={category._id}
            optionText={category?.name}
          />
        ))}
      </SelectInput>
      <ShortTextInput
        label={`Name`}
        value={name}
        placeholder={`Enter Name`}
        setState={setName}
      />

      <ShortTextInput
        label={`Description`}
        value={description}
        placeholder={`Enter Description`}
        setState={setDescription}
      />
      <ShortTextInput
        label={`BackgroundColor`}
        value={backgroundColor}
        placeholder={`Enter BackgroundColor`}
        setState={setBackgroundColor}
      />
      <NumberInput
        label={`Precedence`}
        value={precedence}
        placeholder={`Enter precedence`}
        setState={setPrecedence}
      />
      <ImageInput
        fieldId="1"
        state={image}
        setState={setImage}
        allowUpdateImage
      >
        Upload Image
      </ImageInput>

      <FormSubmitButton text="Update" />
    </Form>
  );
}

export default UpdateOurSolution;
